export default __webpack_public_path__ + "static/media/head03_th_pc@2x.db070060.png";